module.exports = __webpack_public_path__ + "static/img/ent-70.c5f842d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-70.jpg
// module id = Y9c6
// module chunks = 52